import React from 'react';
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FiFlag } from "react-icons/fi";
import { BsFillXCircleFill, BsCheckCircleFill } from "react-icons/bs";
import "./GHGEmissionsUpsale.scss";
import GHGEmissionsOverview from '../images/GHG_dashboard.png';
import GHGEmissionsInventory from '../images/GHG_Emission.png';

const GHGEmissionsUpsale = ({ t }) => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate("/company_admin/home");
  };

  const handleContactUpgrade = () => {
    // Handle contact upgrade action
    console.log("Contact upgrade clicked");
  };

  return (
    <div className="ghg-emissions-upsale" data-testid="ghg-emissions-upsale">
      {/* Top Section - Light Gray Background */}
      <section className="top-section" data-testid="top-section">
        <div className="container">
          <div className="row align-items-center m-0">
            {/* Left Column - Content */}
            <div className="col-lg-5" data-testid="top-left-column">
              <div className="content-wrapper">
                <h1 className="section-title" data-testid="top-section-title">
                  {t("GHGEmissionsUpsale.topSection.title.label")}
                </h1>
                <p className="section-description" data-testid="top-section-description">
                  {t("GHGEmissionsUpsale.topSection.description.label")}
                </p>
                <div className="mb-4" data-testid="upgrade-notice">
                  <b>
                    {t("GHGEmissionsUpsale.topSection.upgradeNotice.label")}
                  </b>
                </div>
                <div className="button-group" data-testid="button-group">
                  <button
                    className="btn btn-primary btn-lg me-3"
                    onClick={handleContactUpgrade}
                    data-testid="contact-upgrade-button"
                  >
                    {t("GHGEmissionsUpsale.topSection.contactUpgradeButton.label")}
                  </button>
                  <button
                    className="btn btn-outline-secondary home-btn"
                    onClick={handleBackToHome}
                    data-testid="upgrade-btn"
                  >
                    {t("SaaSUpgrade.topSection.goToHome.label")}
                  </button>

                </div>
              </div>
            </div>

            {/* Right Column - Image */}
            <div className="col-lg-7" data-testid="top-right-column">
              <div className="image-wrapper">
                <img
                  src={GHGEmissionsOverview}
                  alt={t("GHGEmissionsUpsale.topSection.imageAlt.label")}
                  className="dashboard-image"
                  data-testid="dashboard-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Middle Section - White Background */}
      <section className="middle-section" data-testid="middle-section">
        <div className="container">
          <div className="row align-items-center m-0">
            {/* Left Column - Image */}
            <div className="col-lg-6" data-testid="middle-left-column">
              <div className="image-wrapper">
                <img
                  src={GHGEmissionsInventory}
                  alt={t("GHGEmissionsUpsale.middleSection.imageAlt.label")}
                  className="inventory-image"
                  data-testid="inventory-image"
                />
              </div>
            </div>

            {/* Right Column - Content */}
            <div className="col-lg-6" data-testid="middle-right-column">
              <div className="content-wrapper">
                <h2 className="section-title" data-testid="middle-section-title">
                  {t("GHGEmissionsUpsale.middleSection.title.label")}
                </h2>
                <ul className="benefits-list" data-testid="benefits-list">
                  <li data-testid="benefit-1">
                    <FiFlag className="check-icon" />
                    <span>{t("GHGEmissionsUpsale.middleSection.benefit1.label")}</span>
                  </li>
                  <li data-testid="benefit-2">
                    <FiFlag className="check-icon" />
                    <span>{t("GHGEmissionsUpsale.middleSection.benefit2.label")}</span>
                  </li>
                  <li data-testid="benefit-3">
                    <FiFlag className="check-icon" />
                    <span>{t("GHGEmissionsUpsale.middleSection.benefit3.label")}</span>
                  </li>
                  <li data-testid="benefit-4">
                    <FiFlag className="check-icon" />
                    <span>{t("GHGEmissionsUpsale.middleSection.benefit4.label")}</span>
                  </li>
                  <li data-testid="benefit-5">
                    <FiFlag className="check-icon" />
                    <span>{t("GHGEmissionsUpsale.middleSection.benefit5.label")}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom Section - Comparison Table */}
      <section className="bottom-section" data-testid="bottom-section">
        <div className="container px-4">
          <div className='mb-3'>
            <h4 className="step-up-title fw-bold" data-testid="step-up-title">
              Step Up Your Plan
            </h4>
          </div>
          <div className='row m-0 OurPlansSection'>
            <div className='col-md-6 p-2'>
              <div className='OurPlansSection_List'>
                <ul>
                  <li className='OurPlansSection_List_Header'>
                    <h6 className='mb-0'>{t("OurPlans.label")}</h6>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("GHGEmissionsUpsale.bottomSection.scopeCoverage.label")}</h6>
                    <p>{t("GHGEmissionsUpsale.bottomSection.scopeCoverage.plan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("GHGEmissionsUpsale.bottomSection.calculationMethods.label")}</h6>
                    <p>{t("GHGEmissionsUpsale.bottomSection.calculationMethods.plan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("GHGEmissionsUpsale.bottomSection.emissionFactors.label")}</h6>
                    <p>{t("GHGEmissionsUpsale.bottomSection.emissionFactors.plan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("GHGEmissionsUpsale.bottomSection.datacapture.label")}</h6>
                    <p>{t("GHGEmissionsUpsale.bottomSection.datacapture.plan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("GHGEmissionsUpsale.bottomSection.report.label")}</h6>
                    <p>{t("GHGEmissionsUpsale.bottomSection.report.plan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("GHGEmissionsUpsale.bottomSection.analytics.label")}</h6>
                    <p>{t("GHGEmissionsUpsale.bottomSection.analytics.plan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("GHGEmissionsUpsale.bottomSection.auditTrail.label")}</h6>
                    <p>{t("GHGEmissionsUpsale.bottomSection.auditTrail.plan.label")}</p>
                  </li>

                </ul>
              </div>
            </div>
            <div className='col-md-3 p-2'>
              <div className='OurPlansSection_List Current-planList'>
                <ul>
                  <li className='OurPlansSection_List_Header'>
                    <h6 className='mb-0'>
                      {t("GolasKpisUpsale.bottomSection.table.currentPlan.label")}
                    </h6>
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-md-3 p-2'>
              <div className='OurPlansSection_List Current-planList'>
                <ul>
                  <li className='OurPlansSection_List_Header'>
                    <h6 className='mb-0'>
                      {t("GolasKpisUpsale.bottomSection.table.upgradedPlan.label")}
                    </h6>
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li> <BsCheckCircleFill className='text-success' /></li>
                  <li> <BsCheckCircleFill className='text-success' /></li>


                </ul>
              </div>
            </div>
          </div>
          <div className="button-group text-right p-2" data-testid="button-group">
            <a
              href="mailto:info@ecodrisil.com"
              className="btn btn-primary upgrade-btn"
            >
              {t("GolasKpisUpsale.topSection.upgradeButton.label")}
            </a>
          </div>

        
        </div>
      </section>
    </div>
  );
};

export default withTranslation()(GHGEmissionsUpsale);
